/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 200, height: 100, ...sx }}>
      <img src="/logo/airstudiologo.png" alt="" style={{ height: 'auto', width: '100%', maxWidth: '100%' }} />
    </Box>
  );

  // if (disabledLink) {
  return <>{logo}</>;
  // }

  // return <RouterLink to="/">{logo}</RouterLink>;
}
